import { Component } from '@angular/core';

@Component({
  selector: 'app-crear-departamento',
  templateUrl: './crear-departamento.component.html',
  styleUrls: ['./crear-departamento.component.scss']
})
export class CrearDepartamentoComponent {

  public Departamento = [
    { value: "1", label: "AMAZONAS", job: "Developer" },
    { value: "2", label: "QUINDIO", job: "Developer" },
    { value: "3", label: "ANTIOQUIA", job: "Designer" },

  ];
  public departamento: string;
  ngOnInit(): void {}
}